import { ImageBackground, View, Image } from "react-native";

import { MediaQuery, Text } from "UpduoLibrary";
import BackgroundGradient from "assets/gradients/upduo-colors-04.svg";
import UpduoLogo from "assets/upduo-logo.svg";
import UpduoSwoosh from "assets/upduo-swoosh/swoosh-middle.svg";

export default function BrandingArea() {
  return (
    <MediaQuery minWidth={1000}>
      <ImageBackground
        style={{
          flex: 4,
          flexDirection: "column",
          alignSelf: "stretch",
        }}
        source={{ uri: BackgroundGradient }}
      >
        <Image
          style={{
            width: 150,
            height: 50,
            margin: 32,
            resizeMode: "contain",
          }}
          accessibilityLabel={"updudo"}
          source={{ uri: UpduoLogo }}
        />
        <View
          style={{
            flexGrow: 1,
            flexShrink: 1,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <View
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <View
              style={{
                alignSelf: "stretch",
                flexGrow: 1,
                flexShrink: 1,
                borderBottomColor: "white",
                borderBottomWidth: 5,
                borderStyle: "solid",
              }}
            />
            <Image
              style={{
                height: 378,
                width: 942,
                resizeMode: "cover",
                flexGrow: 0,
                flexShrink: 1,
              }}
              source={{ uri: UpduoSwoosh }}
            />
            <View
              style={{
                alignSelf: "stretch",
                flexGrow: 1,
                flexShrink: 1,
                borderTopColor: "white",
                borderTopWidth: 5,
                borderStyle: "solid",
              }}
            />
          </View>
          <Text
            style={{
              marginTop: 32,
              marginLeft: 42,
              fontSize: 32,
              color: "white",
              lineHeight: 45,
            }}
          >
            {"Learn together. Grow together.\nDo great things with Upduo."}
          </Text>
        </View>
      </ImageBackground>
    </MediaQuery>
  );
}
